<template>
    <div class="lg:px-40">
        <div class="lg:flex lg:gap-4 lg:border-deliRed lg:border-y pb-5 lg:px-0 px-2">
            <div class="lg:p-4">
                <h2 class="text-2xl italic">Menu</h2>
            </div>

            <div class="lg:p-4">
                <ul class="list-disc pl-5">
                    <li>Expresso</li>
                    <li>Cappuccino</li>
                    <li>Mate</li>
                </ul>
            </div>
            <div class="lg:p-4">
                <ul class="list-disc pl-5">
                    <li>Grilled Ham and Cheese</li>
                    <li>Pão de Queijo</li>
                    <li>Cookies</li>
                </ul>
            </div>
        </div>

        <!-- <div>
            <div>
                <h2 class="italic text-2xl my-4">Contributor</h2>
            </div>
            <div class="lg:flex lg:gap-4">
                <div class="lg:flex-[1]">
                    <img src="@/assets/img/chef-in-residence.jpeg" class="w-full" />
                </div>
                <div class="lg:flex-[3] font-light">
                    <div>
                        <p class="text-2xl my-2">
                            Chef in residence: Zacarías González
                        </p>
                        <p class="pt-2">
                            (b. 1984, Cuban) As an artist and filmmaker, my work bridges art and everyday life, using
                            creative practices to inspire social interaction and reimagine engagement with
                            socio-political
                            systems. My projects are site-specific, challenging behaviors and negotiating processes to
                            explore arte útil as a tool for reflection and collective action. Focused on long-term,
                            collaborative projects, I function as an initiator, inviting participants as co-creators to
                            challenge dominant power structures. My current project, Food Futures, critically examines
                            agriculture through communal meals, workshops, research, and an audiovisual series of films
                            and sound pieces. In collaboration with Creative Time, the Institute of Public Architecture, and
                            diverse contributors—artists, farmers, herbalists, and academics—it envisions sustainable
                            agricultural models that address ecological and social challenges, proposing systems that
                            nourish both people and the planet.
                        </p>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>